import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import TableCell from "@mui/material/TableCell";

import { setError, setSuccess } from "../../reducers/appSlice";
import api from "../../service/api";
import ModalEmail from "../../commons/ModalEmail";
import Accion from "../../components/Accion";
import SimpleTable from "../../components/SimpleTable";
import AgregarIniciador from "../../components/AgregarIniciador";
import ConfirmDialog from "../../components/ConfirmDialog";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";

const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
}));

const DatosIniciadores = (props) => {
  const { actualizarDatos, ...other } = props;
  const dispatch = useDispatch();
  const [iniciadores, setIniciadores] = useState(props.iniciadores);
  const [filteredIniciadores, setFilteredIniciadores] = useState([]);
  const [datosMovimiento, setDatosMovimiento] = useState([]);
  const [tienePermisoAgregarAdjunto, setTienePermisoAgregarAdjunto] = useState("N");
  const [filtro] = useState({
    id_tramite: props.tramiteId,
  });
  const [filter, setFilter] = useState();
  const [usuario, setUsuario] = useState(null);
  const [disable, setDisable] = useState(false);
  const headers = [
    
    {
      id: "nombre",
      padding:"normal",
      label: "Iniciadores",
      align:"left",
       width: "300",
      
    },
    {
      id: "domicilio",
      label: "Domicilio",
      align:"left",
      padding:"normal",
      width: "300",
    },
    {
      id: "email",
      label: "E-mail",
      align:"left",
      padding:"normal",
      width: "300",
    },
    {
      id: "acciones",
      label: "Acciones",
      align: "center",
      width: "200",
    },
  ];
  const handleEmail = async (resultado) => {
    try {
      if (resultado.personaId) {
        await api.actualizarEmailIniciador({
          personaId: resultado.personaId,
          tramiteId: props.tramiteId,
          email: resultado.email
        });
      } else {
        await api.actualizarEmailIniciadorOrganismo({
          organismoId: resultado.organismoId,
          tramiteId: props.tramiteId,
          email: resultado.email
        });
      }


      dispatch(setSuccess("E-mail actualizado"))

      let involucrados = [...iniciadores];

      for (let index = 0; index < involucrados.length; index++)
        if (involucrados[index].personaId === resultado.personaId)
          involucrados[index].email = resultado.email;

      setIniciadores(involucrados);
    } catch (e) {
      dispatch(setError("Error al actualizar el e-mail"));
    }
  };
  const accionConfirmarEliminar = (id) => {

    api
      .eliminarIniciador({ involucradoId:id })
      .then((res) => {
        actualizarDatos();
        dispatch(setSuccess("Se eliminó el iniciador con éxito"));
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      });

  }
  useEffect(() => {
    async function buscarPermisoAgregarAdjuntos() {
      try {
        let filtro = {
          tra_id: props.tramiteId,
        };
        let res = await api.buscarPermisoAgregarAdjuntos(filtro);
        setTienePermisoAgregarAdjunto(res.data[0].tiene_permiso);
      } catch (e) {
        dispatch(
          setError(
            "Error al consultar los permisos"
          )
        );
      }
    }
    buscarPermisoAgregarAdjuntos();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.tramiteId]);

  useEffect(() => {
    let iniciadores = [];
    for (let index = 0; index < props.iniciadores.length; index++) {
      let nombre = "";
      if (props.iniciadores[index].nombres_f) {
        nombre =
          props.iniciadores[index].apellido_f +
          ", " +
          props.iniciadores[index].nombres_f;
      } else if (props.iniciadores[index].razon_social_j) {
        nombre = props.iniciadores[index].razon_social_j;
      } else if (props.iniciadores[index].organismo) {
        nombre = props.iniciadores[index].organismo;
      }

      let iniciador = {
        id: props.iniciadores[index].id
          ? props.iniciadores[index].id
          : null,
        personaId: props.iniciadores[index].id_persona
          ? props.iniciadores[index].id_persona
          : null,
        organismoId: props.iniciadores[index].cod_organismo
          ? props.iniciadores[index].cod_organismo
          : null,
        localidadId: null,
        domicilioId: null,
        domicilio: props.iniciadores[index].domicilio
          ? props.iniciadores[index].domicilio
          : "",
        email: props.iniciadores[index].email
          ? props.iniciadores[index].email
          : "",
        nombre: nombre,
      };
      iniciadores.push(iniciador);
    }

    setIniciadores(iniciadores);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.iniciadores]);
  const filterData = (element) => {
    const searchFilter = filter.toLowerCase();
      return (
        element.nombre?.toLowerCase().includes(searchFilter) ||
        element.email?.toLowerCase().includes(searchFilter) ||
        element.domicilio?.toLowerCase().includes(searchFilter) 
      );
  };

  useEffect(() => {
    if (iniciadores) {
        if (filter) {
          setFilteredIniciadores(iniciadores.filter(dato => filterData(dato)));
        } else {
          setFilteredIniciadores(iniciadores);
        }
      }
  }, [iniciadores, filter]);
  useEffect(() => {
    api
      .datosUsuario()
      .then((res) =>
        setUsuario({
          nombre: res.data.apellido + ", " + res.data.nombre,
          email: res.data.email,
          organismoId: res.data.organismo,
          organismo: res.data.organismoDesc,
          perfil: res.data.perfilDesc,
          grupo: res.data.grupo,
          entrada: res.data.entrada,
        })
      )
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const buscarMovimientos = (filtro) => {
    api
      .buscarMovimiento(filtro)
      .then((res) => {
        setDatosMovimiento(res.data.movimientos);
      })
      .catch((e) => {
        console.log(e);
        dispatch(setError("Error al cargar los datos"));
      });
  };
  useEffect(() => {
    buscarMovimientos(filtro);
  }, []);
  useEffect(() => {
    if(usuario){
      if(datosMovimiento.length === 1 && datosMovimiento[0].tipo_movimiento==="INICIO TRAMITE" && Number(props.iniciador_id)===Number(usuario.organismoId)){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }
  }, [datosMovimiento,props.iniciador_id,usuario]);
  return (
    <>
     <Accion funcion={props.funcion} accion="alta"> 
        <Paper sx={{py:2,px:2,mt:2}}>
                    
          <AgregarIniciador tramite_id={props.tramiteId} actualizarDatos={actualizarDatos} disable={disable} />
          
        </Paper>     
       </Accion>     
     <Paper sx={{py:2,px:2,mt:2}}>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <TextField id="filtro" label="Buscar" variant="outlined" size="small" value={filter} onChange={(event) => setFilter(event.target.value)} />
        </Box> 
        <SimpleTable
          headers={headers}
          rows={filteredIniciadores.map((iniciador) => ({
          ...iniciador,
          acciones: ( 
          <>
              <ModalEmail
                  iniciador={iniciador}
                  resultado={handleEmail}
                  tienePermisoAgregarAdjunto={tienePermisoAgregarAdjunto}
                />
                <ConfirmDialog
                  text={`Vas a eliminar el iniciador ${iniciador.nombre}`}
                  subText="¿Querés continuar?"
                  icon={<DeleteOutlined  text="Eliminar" fontSize="small" />}
                  iconTitle="Eliminar iniciador"
                  mostrar={disable===true?'N':""}
                  handleConfirm={accionConfirmarEliminar}
                  data={Number(iniciador.id)}
                />
            </>
          ),
          }))}
        />
    </Paper>
  </>
  );
};

export default DatosIniciadores;
